import React from "react";
import { Pagination } from "antd";

function PaginationComponent({ handlePagination, Size = 0, itemsPerPage = 8, currentPage = 1 }) {
  if (!Size || Size <= itemsPerPage) return null;

  return (
    <div className="flex justify-center items-center my-10 py-2">
      <div className="bg-white px-4 py-2 rounded-2xl shadow-sm border border-amber-100">
        <Pagination
          current={currentPage}
          total={Size}
          pageSize={itemsPerPage}
          onChange={(page) => handlePagination(page)}
          showSizeChanger={false}
          className="product-pagination"
        />
      </div>
    </div>
  );
}

export default PaginationComponent;
